import { render } from "./UiElementSettings.vue?vue&type=template&id=12d316e8"
import script from "./UiElementSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UiElementSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./UiElementSettings.vue?vue&type=style&index=0&id=12d316e8&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__